let testimonial = document.querySelector(".splide.unicat-testimonial-slider");

if (testimonial) {
  let splide = new Splide(testimonial, {
    type: "loop",
    gap: 20,
    pagination: false,
    perPage: 3,
    classes: {
      arrows: "splide__arrows unicat-testimonial-card-splide-arrows",
      arrow: "splide__arrow unicat-testimonial-card-splide-arrow",
      prev: "splide__arrow--prev unicat-testimonial-card-splide-prev",
      next: "splide__arrow--next unicat-testimonial-card-splide-next",
    },
    breakpoints: {
      1200: {
        perPage: 2,
      },
      767: {
        perPage: 1,

        padding: "0rem",
      },
    },
  });

  splide.mount();
}

let stories = document.querySelector(".splide.wun-stories-slider");

if (stories) {
    let splide2 = new Splide(stories, {
    type: "loop",
    gap: 50,
    padding: "20rem",
    perPage: 3,
    arrows: false,
    pagination: false,
    breakpoints: {
      767: {
        padding: "0rem",
        perPage: 1,
      },
    },
  });

  splide2.mount();
}

let partner = document.querySelector(".splide.wun-partner-slider");

if (partner) {
   let splide3 = new Splide(partner, {
    type: "loop",
    perPage: 5,
    gap: 10,
    perMove: 1,
    arrows: true,
    pagination: false,
    breakpoints: {
      767: {
        padding: "0rem",
        perPage: 2,
      },
    },
  });

  splide3.mount();
}

setInterval(() => {
  $(window).resize(function () {
    var outerHeight = $(".quantity-breaks-now-discount-tiers").outerHeight();
    $(".quantity-breaks-now-wrapper").outerHeight(outerHeight);
    // $("div#wun-payment-method").css("margin-top", outerHeight + 30);
  });

  var outerHeight = $(".quantity-breaks-now-discount-tiers").outerHeight();
  $(".quantity-breaks-now-wrapper").outerHeight(outerHeight);
  // $("div#wun-payment-method").css("margin-top", outerHeight + 30);
}, 100);

if(document.querySelector('.toggle-group-price')){

document.querySelector('.toggle-group-price').onclick = function(){
  document.querySelector('.quantity-breaks-now-discount-table').classList.toggle('show');
};
}
